module.exports = __webpack_public_path__ + "static/media/tulleord-norming-tutorial-2.7b438f9d.mp3";